import Errors from './errors';

export default {
  Errors,
};
